import { instance } from '@/services/klarbuss-api'
import { Arrival } from '@/types/arrival'
import { AxiosResponse } from 'axios'

export function getArrival(
  arrivalUuid: string
): Promise<AxiosResponse<Arrival>> {
  return instance.get(`/arrival/${arrivalUuid}`)
}
